import { EmptyObject } from 'type-fest'

import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { SignOutData } from '../types/signOut'

export const SIGN_OUT: TypedDocumentNode<SignOutData, EmptyObject> = gql`
  ${ERROR_FRAGMENT}

  mutation signOut {
    signOut(input: {}) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
